// extracted by mini-css-extract-plugin
export default {"main":"FAQ_main__aI2iD","dark":"FAQ_dark__NBPib"};